<template>
  <div>
    <div class="px-3 py-2">
      <b-row class="align-items-center">
        <b-col sm="8">
          <b-button size="sm"
                    :variant="addFilter ? 'dark' : 'outline-dark'"
                    @click="addFilter = !addFilter">
            Add Filter
          </b-button>
        </b-col>
        <b-col sm="4">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="icon-magnifier"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text"
                          class="form-control"
                          placeholder="Search by invoice number"
                          autocomplete="off"
                          v-model="serverParams.keyword"
                          @input="onChange" />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div v-show="addFilter" class="px-3 p-2 border-top">
      <b-row>
        <b-col sm="4">
          <b-form-input type="text"
                        placeholder="Account#"
                        autocomplete="off"
                        v-model="serverParams.accountId"
                        @input="onChange" />
        </b-col>
        <b-col sm="4">
          <b-form-input type="text"
                        placeholder="Account Name"
                        autocomplete="off"
                        v-model="serverParams.accountName"
                        @input="onChange" />
        </b-col>
        <b-col sm="4">
          <b-form-input type="text"
                        placeholder="Email"
                        autocomplete="off"
                        v-model="serverParams.email"
                        @input="onChange" />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="4">
          <form-group label="Period" :use-horizontal="false">
            <b-form-input type="month"
                          placeholder="Period"
                          autocomplete="off"
                          v-model="serverParams.period"
                          @input="onChange" />
          </form-group>
        </b-col>
        <b-col sm="4">
          <form-group label="Payment Status" :use-horizontal="false">
            <treeselect v-model="serverParams.paymentStatus"
                        placeholder="Select Payment Status"
                        :options="options.paymentStatus"
                        :multiple="true"
                        :clearable="true"
                        @input="onChange" />
          </form-group>
        </b-col>
        <b-col sm="4">
          <form-group label="‎‎ " :use-horizontal="false">
            <BuildingDropdown :server-params="serverParams"
                              :on-select="onChange" />
          </form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { paymentStatus } from "@/shared/options";
  import BuildingDropdown from "@/components/common/BuildingDropdown";
  export default {
    props: {
      serverParams: Object,
    },
    components: {
      BuildingDropdown,
    },
    data: () => ({
      addFilter: false,
      options: {
        paymentStatus,
      },
    }),
    methods: {
      onChange() {
        this.serverParams.pageNumber = 1;
        this.$emit("onChange", this.serverParams);
      },
    },
  };
</script>
